module.exports = __webpack_public_path__ + "img/pwa-installed-award.009a2704.png";